import { allRoles } from "../../assets/constants";
export const firstCreditz = (index) =>({
    role: allRoles[index],
    email: "",
    selectedUsername: { value: "", label: "" },
    selectedRole: { value: allRoles[index], label: allRoles[index] }
  });
 export const secondCreditz =(index) =>({
  role: allRoles[index],
  email: "",
  selectedUsername: { value: "", label: "" },
  selectedRole: { value: allRoles[index], label: allRoles[index] }
});

  export const thirdCreditz = (index) =>({
    role: allRoles[index],
    email: "",
    selectedUsername: { value: "", label: "" },
    selectedRole: { value: allRoles[index], label: allRoles[index] }
  });
  export const forthCreditz = (index) =>({
    role: allRoles[index],
    email: "",
    selectedUsername: { value: "", label: "" },
    selectedRole: { value: allRoles[index], label: allRoles[index] }
  });


  //Audio 0 6 5 11 
  // video  18 29 15 19
